import { render, staticRenderFns } from "./ResponsibleList.vue?vue&type=template&id=43c883ca&"
import script from "./ResponsibleList.vue?vue&type=script&lang=js&"
export * from "./ResponsibleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports